export const disclaimer1 =
  'The data contained herein has been provided by sources ' +
  'believed to be reliable, but such information has not been ' +
  'independently verified by any party. Neither DataTrace ' +
  'Information Services, LLC. nor any other party makes any ' +
  'representation or warranty that the information contained ' +
  'herein is current, accurate or complete, and assume no ' +
  'liability therefore. Subscribers or others with access to ' +
  'this information should validate the information that has ' +
  'been provided via their own sources such as public records ' +
  'or other information.';

export const disclaimer2 =
  'A Private Corporation owns this computer system and ' +
  'restricts access and use to authorized persons only. Use of ' +
  'and/or access to this system and/or any information obtained ' +
  'via this system is subject to the Corporation’s policies and ' +
  'procedures governing such use and access (including, but not ' +
  'limited to, confidentiality, privacy, data and system ' +
  'security, and information protection). Unauthorized or ' +
  'improper use of or access to this system, or any portion of ' +
  'it, either directly or indirectly, or any attempt to deny ' +
  'service to authorized users or to alter, damage, or destroy ' +
  'information, or otherwise to interfere with the system or ' +
  'its operation, is strictly prohibited. Any party using or ' +
  'accessing, or attempting to use or access, this system ' +
  'without express authority from the Corporation may be ' +
  'subject to severe disciplinary action and/or civil and ' +
  'criminal penalties in accordance with applicable state and ' +
  'federal law (including, but not limited to, the Computer ' +
  'Fraud and Abuse Act of 1986 and the Electronic ' +
  'Communications Privacy Act). The Corporation may monitor and ' +
  'record use and access for quality assurance, security, ' +
  'privacy compliance, performance, and maintenance purposes, ' +
  'except as prohibited by law. Any person who uses or accesses ' +
  'this system expressly consents to such monitoring and ' +
  'recording. The Corporation or its representatives may ' +
  'furnish information obtained by its monitoring and recording ' +
  'activity to law enforcement officials if such monitoring and ' +
  'recording reveals possible evidence of unlawful activity.';
